/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useShowMember } from './ShowMemberContext';
import {BioLink} from '../content/serializers'

export const MemberLink = ({ member,children }) => {
	// const [isHover, setHover] = useState(false);
	const showMember = useShowMember();

	if (member.bioSlug) {
		return <BioLink member={member}>{children}</BioLink>
	}

	if (member.content?.flower && member.content?.face) {
		return (
			<span sx={{
				fontWeight: 800, cursor: 'pointer', ':hover': {
					color: '#ff6c3f'
				}
			}} onClick={() => showMember(member)}
			>
				{children}
			</span>
		);
	}
	return <span>{children}</span>;
};
